<script setup>
import { ref, onMounted } from 'vue';
import { useRequestsStore } from '@/stores/storeRequests';
import { RouterLink } from "vue-router";
import BaseHorizontalTitleScroll from '@/components/blocks/BaseHorizontalTitleScroll.vue' 

const storeRequests = useRequestsStore();

const activeContent = ref({})
const listInfoCourts = ref([])

const showHiddenContent = id => activeContent.value[id] = !activeContent.value[id]; 

onMounted( async () => {
    listInfoCourts.value = await storeRequests.getInfoCourts();
})

</script>
<template>
    <section class="playgrounds">
        <div class="container">
            <h2 class="title2 playgrounds__title">Наши игровые <span class="title-border">площадки</span></h2>
            <ul class="playgrounds__list" v-if="listInfoCourts.length">
                <li class="playgrounds__item" v-for="item of listInfoCourts" :key="item.id">
                    <h3 class="title3 playgrounds__name --mobile">{{ item.title }}</h3>
                    <div class="playgrounds__image">
                        <img width="880" height="420" 
                            class="full-img"
                            :src='item.image' alt='изображение'>
                    </div>
                    <div class="playgrounds__content">
                        <h3 class="title3 playgrounds__name">{{ item.title }}</h3>
                        <div class="playgrounds__btns">
                            <button 
                                @click="showHiddenContent(item.id)" 
                                :class="['playgrounds__btn btn --black', { hide: activeContent[item.id] }]">
                                Подробнее
                            </button>
                            <RouterLink to="/services" :class="['playgrounds__btn btn', { hide: activeContent[item.id] }]">Забронировать</RouterLink>
                        </div>
                        <div :class="['playgrounds__hide-content', { active: activeContent[item.id] }]">
                            <div style="min-height: 0px;">
                                <p>{{ item.description }}</p>
                                <div class="playgrounds__btns">
                                    <button @click="showHiddenContent(item.id)" class="btn --black">Свернуть</button>
                                    <RouterLink to="/services" class="btn">Забронировать</RouterLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="playgrounds__horizontal-scroll">
            <BaseHorizontalTitleScroll/>
        </div>
    </section>
    <section class="changing-rooms">
        <div class="container">
            <div class="changing-rooms__block">
                <div class="changing-rooms__image">
                    <img class='full-img' width="734" height="400" src='@/assets/img/playgrounds/playgrounds_6.jpg' srcset='@/assets/img/playgrounds/playgrounds_6@2x.jpg 2x' alt='изображение'>
                </div>
                <div class="changing-rooms__content">
                    <h3 class="changing-rooms__title title3">Раздевалки</h3>
                    <p>Каким бы видом спорта вы ни занимались, у вас всегда есть доступ к комфортным раздевалкам. Здесь можно спокойно переодеться, оставить личные вещи в безопасности и освежиться в душе после тренировки.</p>
                </div>
            </div>
        </div>
    </section>
</template>
<style lang='scss' scoped>

</style>